/**
 * Ticket-cluster toast queue + dedup state — Phase 3.2.c.
 *
 * Pulled out of admin.js. The dedup Map (`notificationRecent`) is keyed
 * by `kind:ticketId` (or `pbx-dead-letter:messageId` etc.) so each kind
 * of notification gets its own throttle window. admin.js still has its
 * own use of `notificationRecent` for PBX dead-letter alerts; that
 * state stays here and both admin.js + tickets.js read/write it via
 * the exported `getNotificationRecent()` accessor.
 */

import { pushToast } from '../../js/notifications.js';
import { resolveTicketDisplay } from './ticket-utils.js';

export const notificationRecent = new Map();

export function queueTicketNotification({ ticketId, kind = 'info', subject, shortCode, message }) {
  if (!ticketId) return;
  const key = `${kind}:${ticketId}`;
  const now = Date.now();
  const lastShown = notificationRecent.get(key) || 0;
  if (now - lastShown < 2500) {
    return;
  }
  notificationRecent.set(key, now);
  const list = window.adminViews && window.adminViews.tickets && window.adminViews.tickets.list;
  const ticket = list && typeof list.findTicketById === 'function' ? list.findTicketById(ticketId) : null;
  const details = resolveTicketDisplay(ticket, ticketId, subject, shortCode);
  let body = message;
  const iconMap = { message: '💬', assignment: '🗂', info: '🔔' };
  const titleMap = {
    message: 'Customer replied',
    assignment: 'Ticket assigned to you',
    info: 'Update',
  };
  if (!body) {
    body = kind === 'message'
      ? `New customer message on ${details.label}`
      : kind === 'assignment'
        ? `${details.label} is now assigned to you`
        : details.label;
  }
  const icon = iconMap[kind] || iconMap.info;
  const title = titleMap[kind] || titleMap.info;
  pushToast({
    id: `${key}-${now}`,
    title,
    message: body,
    icon,
    kind,
    autoCloseMs: kind === 'message' ? 16000 : 18000,
    onClick: () => {
      if (list && typeof list.openFromNotification === 'function') {
        list.openFromNotification(ticketId);
      }
    },
    data: { ticketId },
  });
}
